/* ================================================================
   Per-site brand config (runtime-injected).

   The clone deploy serves ONE shared JS/CSS bundle on all 10 sites.
   Each site's index.html sets `window.__SITE_BRAND__` BEFORE the
   bundle loads (inline <head> script), so every component reads its
   brand from here at module-load time.

   Falls back to 일광오피스 defaults when not injected (dev / original).
   NOTE: 회사 법인 정보(일광엔시스·사업자번호·주소·전화)는 푸터에 고정.
         여기서 바뀌는 건 "표기 브랜드명 / 사이트 URL / 카카오 문의" 뿐.
   ================================================================ */
const DEFAULT_BRAND = {
  name: "일광오피스",          // 표기 브랜드명 (헤더 로고·카피라이트·SEO)
  logo: "ilkwang",             // 로고 텍스트 (액센트 점은 컴포넌트가 붙임)
  url: "https://ikoffices.com",// 사이트 canonical URL (도메인 연결 전엔 ip:port)
  phone: "1600-7542",          // 대표전화 (일광 고정)
  kakaoUrl: "",                // 카카오톡 문의 채널 (전 사이트 동일 / 미설정 시 버튼 숨김)
};

function readBrand() {
  try {
    if (typeof window !== "undefined" && window.__SITE_BRAND__) {
      return { ...DEFAULT_BRAND, ...window.__SITE_BRAND__ };
    }
  } catch (_e) {
    /* noop */
  }
  return DEFAULT_BRAND;
}

export const BRAND = readBrand();
export default BRAND;
